import { Checkbox } from 'antd'
import { useContext } from 'react'
import { CustomizeMoneyFlowContext, MoneyFlowContext } from '../../../context/MoneyFlowContext.tsx'

export const ModeSwitch = () => {
    const { switchMode } = useContext(CustomizeMoneyFlowContext)
    const { mode } = useContext(MoneyFlowContext)

    return (<>
        <Checkbox
            onChange={() => switchMode()}
            defaultChecked={mode === 'depth'}
        >
            Depth-based Entity Split
        </Checkbox>
    </>)
}
